import { useEffect } from "react";
import { useGetDashboardFocusedFeaturesContext } from "../../FocusedFeatures/Dashbaord/useGetDashboardFocusedFeaturesContext";
import { IS_DEV_ENV } from "../../shared/constants/environment";
import { useStoredDefaultSelectedAccount } from "../../modules/SelectOrganizationAccount/utils/useStoredDefaultSelectedAccount";

export const SystemLog = () => {
  const userContext = useGetDashboardFocusedFeaturesContext();
  const [defaultSelectedAccount] = useStoredDefaultSelectedAccount();
  const isUserContextReady = !!userContext;

  useEffect(() => {
    if (isUserContextReady) {
      const { customization, experiments, ...userSettings } = userContext;
      const extendedSettings = {
        ...userSettings,
        defaultSelectedAccount
      };

      Object.entries(extendedSettings).forEach(([key, value]) => {
        const title = `USER_SETTINGS( ${key} )`;
        const content = JSON.stringify(value, null, 2);

        const body = `${title}\n${content}`;

        if (IS_DEV_ENV) {
          console.info(body);
        }

        window.FS?.("log", {
          level: "info",
          msg: body
        });
      });
    }
  }, [isUserContextReady]);

  return null;
};
